module.exports = __webpack_public_path__ + "img/28_76.92c9f0f9.png";